import React from 'react';
import InkindSupportSidebar from './InkindSupportSidebar';
import { ButtonBone, FrameBone, ParagraphBone } from '@gik/ui';
import { useInkind } from '@gik/api/inkinds/inkind';
import repeatElement from '@gik/core/utils/repeatElement';
import { useBemCN } from '@gik/core/utils/bemBlock';

interface InkindSupportSidebarContainerProps {
  inkindRouteId: string;
}

export default function RightSideBarContainer({ inkindRouteId }: InkindSupportSidebarContainerProps): JSX.Element {
  const bem = useBemCN('right-sidebar-container');
  const { data: inkindPage } = useInkind(inkindRouteId);

  if (!inkindPage) {
    return (
      <div {...bem(null, [{ skeleton: true }])} id="right-sidebar">
        <ButtonBone />

        <ParagraphBone words={4} />
        {repeatElement(3, <ButtonBone />)}

        <ParagraphBone words={4} />
        {repeatElement(2, <ButtonBone />)}

        <FrameBone />
      </div>
    );
  } else {
    return <InkindSupportSidebar inkindRouteId={inkindRouteId} />;
  }
}
